import { render, staticRenderFns } from "./fg.vue?vue&type=template&id=75828c3e&scoped=true"
import script from "./fg.vue?vue&type=script&lang=js"
export * from "./fg.vue?vue&type=script&lang=js"
import style0 from "./fg.vue?vue&type=style&index=0&id=75828c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75828c3e",
  null
  
)

export default component.exports